import { settings as raySettings } from '@wework/ray-core';

export function isDesktopBreakpoint() {
  return window.innerWidth >= raySettings.breakpointsInPixels.desktop;
}

export function isMobileBreakpoint() {
  return window.innerWidth < raySettings.breakpointsInPixels.desktop;
}
